<form class="quote-wrapper needs-validation" novalidate [formGroup]="formFields"
  (ngSubmit)="onSubmit(content, referral)">
  <div class="container-fluid">
    <div class="row gx-4">
      <span *ngIf="rating_amount > 10000" class="tbc-info-color">
        Thank you for your request. This will be reviewed by insurers and we will aim to respond within 3 working
        days. Please ensure you click ‘Save and View Quote’ to submit your request.
      </span>
      <!-- LEFT CARD : COVER + PREMIUM -->
      <div class="col-md-6" *ngIf="staticData">
        <div class="quote-card">
          <!-- Select Cover -->
          <!-- Premium Section -->
          <h5 class="section-title">Premium</h5>

          <div class="premium-row">
            <span>Premium Excl IPT</span>
            <span *ngIf="rating_amount <= 10000">£{{ premium_excl_ipt || 0 | number:'1.2-2' }}</span>
            <span *ngIf="rating_amount > 10000">£TBC</span>
          </div>

          <div class="premium-row">
            <span>Insurance Premium Tax (12%)</span>
            <span *ngIf="rating_amount <= 10000">
              £{{
              (ipt_value) || 0
              | number:'1.2-2'
              }}
            </span>
            <span *ngIf="rating_amount > 10000">
              £TBC
            </span>
          </div>

          <div class="premium-row">
            <span>Peliwica Fee</span>
            <span *ngIf="rating_amount <= 10000">£0.00</span>
            <span *ngIf="rating_amount > 10000">£TBC</span>
          </div>
          <!-- <div class="premium-row" *ngIf="store_location_exists">
            <span>10% Loading charges</span>
            <span>£{{loading_charges}}</span>
          </div> -->

          <hr />

          <div class="premium-row total">
            <span>Total Premium Including IPT</span>
            <span *ngIf="rating_amount <= 10000">£{{ premium_incl_ipt || 0 | number:'1.2-2' }}</span>
            <span *ngIf="rating_amount > 10000">£TBC</span>
          </div>

        </div>
      </div>

      <!-- RIGHT CARD : QUOTE SUMMARY -->
      <div class="col-md-6">
        <div class="quote-card">

          <h5 class="section-title">Quote Summary</h5>

          <div class="summary-row">
            <span>Product</span>
            <strong>Peliwica Saddlery & Tack</strong>
          </div>

          <div class="summary-row">
            <span>Quote Reference</span>
            <strong>{{ reference }}</strong>
          </div>

          <div class="summary-row">
            <span>Cover Dates</span>
            <strong>{{ coverPeriod }}</strong>
          </div>

          <div class="mt-4 d-flex gap-2 flex-wrap ml-2" *ngIf="documents?.length">

            <button *ngFor="let doc of documents" type="button" class="btn btn-success btn-sm px-3 ml-2"
              (click)="downloadDocument('download', doc)">
              {{ getDisplayTitle(doc.title) }}
            </button>
            <!-- <a
              [href]="policyWordingDocUrl"
              target="_blank"
              class="btn btn-success btn-sm px-3"
            >
              Policy Wording
            </a>

            <a
              [href]="breakdownWordingDocUrl"
              target="_blank"
              class="btn btn-success btn-sm px-3 ml-2"
            >
              Excess Protect Wording
            </a>

            <a
              [href]="ipidWordingDocUrl"
              target="_blank"
              class="btn btn-success btn-sm px-3 ml-2"
            >
              IPID
            </a> -->
          </div>

        </div>
      </div>

    </div>

    <!-- ACTION BAR -->
    <div class="row mt-4">
      <div class="col-md-12 text-right">
        <button type="button" class="btn btn-success back-btn" (click)="goBack()">
          ← Back
        </button>
        <button type="submit" class="btn btn-success px-4">
          Save and View Quote
        </button>
      </div>
    </div>

  </div>
</form>

<ng-template #content let-modal>
  <div class="modal-body">
    <div class="helptext" [innerHTML]="helptext"></div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default btn-gray" (click)="modal.close()">Close</button>
  </div>
</ng-template>
<ng-template #referral let-modal>
  <div class="modal-body">
    <div class="helptext">Clicking save will send your quote to the underwriter, the quote will then be locked for
      editing until the underwriter decision has been made. If you need to edit your quote please do so before
      clicking save.</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dark" (click)="modal.close()">Exit</button>
    <button type="button" class="btn btn-success" (click)="saveQuote(content)">Save</button>
  </div>
</ng-template>